import { render, staticRenderFns } from "./customer-task-import-show.vue?vue&type=template&id=98de413c&"
import script from "./customer-task-import-show.vue?vue&type=script&lang=js&"
export * from "./customer-task-import-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports